<div [class.readonly]="readonly">
  <label *ngIf="label" [for]="id"
    >{{ label }}
    <app-dc-popover
      *ngIf="helpText"
      [body]="helpText"
      [class.helpText]="helpText"
    ></app-dc-popover
  ></label>
  <form [formGroup]="form">
    <div class="inputContainer input-group">
      <div
        *ngIf="minMaxIndicativeToggle"
        class="finalIndicativeContainer input-group-prepend"
        (click)="toggleFinal()"
      >
        <button
          *ngIf="finalOrIndicative === 'final'"
          class="numPercentButton"
          [disabled]="readonly"
        >
          +
        </button>
        <button
          *ngIf="finalOrIndicative === 'indicative'"
          class="numPercentButton"
          [disabled]="readonly"
        >
          R
        </button>
      </div>
      <ng-container
        *ngIf="finalOrIndicative === 'final'"
        class="inputInnerContainer position-relative"
      >
        <input
          formControlName="value"
          type="text"
          [class]="'form-control input percentNumFinalIndicative value'"
          [readonly]="readonly"
          [placeholder]="!showPlaceholder ? '' : 'Final'"
          autocomplete="new-input"
          [id]="id"
          [value]="form.get('value').value | roundAndFormat: decimalPlaces"
          (keydown)="onKeyDown($event, unit)"
          (input)="onInputChange($event.target.value, 'value')"
        />
        <app-dc-control-validation
          *ngIf="valueControl.touched || control?.touched"
          [status]="valueControl.invalid || control?.invalid ? 'invalid' : ''"
          class="{{
            (valueControl.hasError('required') && valueControl.touched) ||
            (control?.hasError('required') && control?.touched)
              ? 'required'
              : ''
          }}"
          body="{{
            customErrorMessage ? customErrorMessage + '.' + '<br/>' : ''
          }}{{
            valueControl.hasError('required') || control?.hasError('required')
              ? 'Required field' + '.' + '<br/>'
              : ''
          }}{{
            valueControl.hasError('incorrect')
              ? valueControl.errors.message + '.'
              : control?.hasError('incorrect')
              ? control?.errors?.message + '.'
              : ''
          }}"
        ></app-dc-control-validation>
      </ng-container>
      <ng-container
        *ngIf="finalOrIndicative === 'indicative'"
        class="inputInnerContainer"
      >
        <div class="percentNumFinalIndicative minimum position-relative">
          <input
            formControlName="minValue"
            type="text"
            [class]="'form-control input percentNumFinalIndicative'"
            [readonly]="readonly"
            [placeholder]="!showPlaceholder ? '' : 'Minimum'"
            autocomplete="new-input"
            [id]="id"
            [value]="form.get('minValue').value | roundAndFormat: decimalPlaces"
            (keydown)="onKeyDown($event, unit)"
            (input)="onInputChange($event.target.value, 'minValue')"
          />
          <app-dc-control-validation
            *ngIf="minValueControl.touched"
            [status]="minValueControl.invalid ? 'invalid' : ''"
            class="{{
              minValueControl.hasError('required') && minValueControl.touched
                ? 'required'
                : ''
            }}"
            body="{{
              customErrorMessage ? customErrorMessage + '.' + '<br/>' : ''
            }}{{
              minValueControl.hasError('required')
                ? 'Required field' + '.' + '<br/>'
                : ''
            }}{{
              minValueControl.hasError('incorrect')
                ? minValueControl.errors.message + '.'
                : ''
            }}"
          ></app-dc-control-validation>
        </div>
        <div class="percentNumFinalIndicative indicative position-relative">
          <input
            formControlName="indicativeValue"
            type="text"
            [class]="'form-control input percentNumFinalIndicative'"
            [readonly]="readonly"
            [placeholder]="!showPlaceholder ? '' : 'Indicative'"
            autocomplete="new-input"
            [id]="id"
            [value]="
              form.get('indicativeValue').value | roundAndFormat: decimalPlaces
            "
            (keydown)="onKeyDown($event, unit)"
            (input)="onInputChange($event.target.value, 'indicativeValue')"
          />
          <app-dc-control-validation
            *ngIf="indicativeValueControl.touched"
            [status]="indicativeValueControl.invalid ? 'invalid' : ''"
            class="{{
              indicativeValueControl.hasError('required') &&
              indicativeValueControl.touched
                ? 'required'
                : ''
            }}"
            body="{{
              customErrorMessage ? customErrorMessage + '.' + '<br/>' : ''
            }}{{
              indicativeValueControl.hasError('required')
                ? 'Required field' + '.' + '<br/>'
                : ''
            }}{{
              indicativeValueControl.hasError('incorrect')
                ? indicativeValueControl.errors.message + '.'
                : ''
            }}"
          ></app-dc-control-validation>
        </div>
        <div class="percentNumFinalIndicative position-relative">
          <input
            formControlName="maxValue"
            type="text"
            [class]="'form-control input percentNumFinalIndicative'"
            [readonly]="readonly"
            [placeholder]="!showPlaceholder ? '' : 'Maximum'"
            autocomplete="new-input"
            [id]="id"
            [value]="form.get('maxValue').value | roundAndFormat: decimalPlaces"
            (keydown)="onKeyDown($event, unit)"
            (input)="onInputChange($event.target.value, 'maxValue')"
          />
          <app-dc-control-validation
            *ngIf="maxValueControl.touched"
            [status]="maxValueControl.invalid ? 'invalid' : ''"
            class="{{
              maxValueControl.hasError('required') && maxValueControl.touched
                ? 'required'
                : ''
            }}"
            body="{{
              customErrorMessage ? customErrorMessage + '.' + '<br/>' : ''
            }}{{
              maxValueControl.hasError('required')
                ? 'Required field' + '.' + '<br/>'
                : ''
            }}{{
              maxValueControl.hasError('incorrect')
                ? maxValueControl.errors.message + '.'
                : ''
            }}"
          ></app-dc-control-validation>
        </div>
      </ng-container>
      <div
        class="percentNumberContainer input-group-append"
        [ngClass]="{ lock: lockDefault }"
        *ngIf="showUnitToggle"
        (click)="toggleValues()"
      >
        <button
          *ngIf="unit === 'abs'"
          [ngClass]="unit === 'abs' ? 'selected' : ''"
          class="numPercentButton"
          (click)="setUnit('abs')"
          [disabled]="readonly"
        >
          #
        </button>
        <button
          *ngIf="unit === 'pct'"
          [ngClass]="unit === 'pct' ? 'selected' : ''"
          class="numPercentButton"
          (click)="setUnit('pct')"
          [disabled]="readonly"
        >
          %
        </button>
      </div>
    </div>
  </form>
</div>
